import React from "react";
import { Signal, SignalHandler } from "../../signals";

interface Props<T, U> {
    handler: SignalHandler<T, U>;
    signal: Signal<T, U>;
}

/**
 * Takes care of adding and removing signal handlers from signals according to react lifecycle.
 */
export class SignalListener<T, U> extends React.PureComponent<Props<T, U>> {
    componentDidMount() {
        const { signal, handler } = this.props;
        if (signal != null && handler != null) {
            signal.add(handler);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props<T, U>) {
        const { signal, handler } = this.props;
        if (nextProps.handler !== handler || nextProps.signal !== signal) {
            if (signal != null && handler != null) {
                signal.remove(handler);
            }
            if (nextProps.signal != null && nextProps.handler != null) {
                nextProps.signal.add(nextProps.handler);
            }
        }
    }

    componentWillUnmount() {
        const { signal, handler } = this.props;
        if (signal != null && handler != null) {
            signal.remove(handler);
        }
    }

    render(): JSX.Element {
        return null;
    }
}
